import { DataResult, State, process } from "@progress/kendo-data-query";
import {
  Grid,
  GridColumn,
  GridNoRecords,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";
import { useEffect, useState } from "react";
import { IMilkModel } from "./milk-model";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import { API_END_POINT } from "../../constants";
import HomePageModel from "../../models/transaction/homepage-model";
import { RefreshIcon } from "../../assets/images/refresh-icon";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import dayjs from "dayjs";

interface IDashboardProps {
  type: string;
  pOrderDate?: Date;
}

const Products: React.FunctionComponent<IDashboardProps> = ({
  ...props
}) => {
  const [orderDate, setOrderDate] = useState<string>("");
  const [homePageProductDetail, setHomepageProductDetail] = useState<
    HomePageModel[]
  >([]);

  const initialDataState: State = {
    take: 50,
    skip: 0,
  };
  const [dataStateArray, setDataStateArray] = useState<State>(initialDataState);
  const [gridData, setGridData] = useState<DataResult>({ data: [], total: 0 });
  const [resultData, setResultData] = useState<DataResult>();
  const [result, setResult] = useState<any[]>([]);
  const [isLoadingFermented, setIsLoadingFermented] = useState(false);

  useEffect(() => {
    const formattedDate = dayjs(props?.pOrderDate).format("YYYY-MM-DD");
    setOrderDate(formattedDate);

    fetchProductData(formattedDate);
  }, [props?.pOrderDate]);

  const fetchProductData = async (orderDate: string) => {
    const url =
      getEndPoint(API_END_POINT.ORDER) +
      `/api/HomePage/GetHomePageMilkDetails/${orderDate}/3`;

    console.log("Fetching fermented milk data from:", url);

    try {
      setIsLoadingFermented(true);
      const response = await getDataWithToken<any>(url);
      const detailList = response?.data?.result || [];
      setHomepageProductDetail(detailList);
    } catch (error) {
      console.error("Error fetching fermented milk data:", error);
    } finally {
      setIsLoadingFermented(false);
    }
  };

  const handleDataStateChange = (e: GridPageChangeEvent) => {
    const newDataState = { skip: e.page.skip, take: e.page.take };
    setDataStateArray(newDataState);
  };

  return (
    <>
      <div className="card p-3 border-0 sw-shadow radius-15">
        <div className="d-flex mb-2">
          <h4>{props?.type}</h4>
          <OverlayTrigger
            overlay={(props) => <Tooltip {...props}>Reload the grid</Tooltip>}
            placement="bottom-start"
          >
            <div
              className="d-flex ms-auto refresh-container"
              onClick={() => fetchProductData(orderDate)}
            >
              <RefreshIcon></RefreshIcon>
            </div>
          </OverlayTrigger>
        </div>
        {isLoadingFermented ? (
          <LoadingIndicator
            isLoading={isLoadingFermented}
            title="reloading.."
          /> // your spinner component or loading text
        ) : (
          <Grid
          style={{ height: "400px" }}
          data={homePageProductDetail}
          pageable={{ pageSizes: [50, 100, 200, 500] }}
          skip={dataStateArray.skip}
          take={dataStateArray.take}
          total={gridData.total}
          sortable={true}
          groupable={false}
          {...dataStateArray}
          onPageChange={(e) => handleDataStateChange(e)}
          columnVirtualization={false}
          resizable={true}
        >
          <GridColumn field="product" title="Product" filter={"text"} />
          {/* <GridColumn field="unit" title="Unit" filter={"text"} /> */}
          <GridColumn field="productTotalQty" title="Qty" filter={"text"} />
          <GridColumn field={"amount"} filter={"text"} title="Amount" />
          <GridNoRecords>
            <div style={{ width: "100%", height: "500px" }}>
              <center>No data found</center>
            </div>
          </GridNoRecords>
        </Grid>
        )}
      </div>
    </>
  );
};
export default Products;




